"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.mapToNewFiltersStructure = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _agent = require("@deosite/agent");
var _mapProductDataNew = _interopRequireDefault(require("@deosite/helpers/mapProductDataNew"));
var _moveOutOfStockProductsLast = _interopRequireDefault(require("@deosite/helpers/moveOutOfStockProductsLast"));
var _getSearchUrl = _interopRequireDefault(require("@deosite/helpers/getSearchUrl"));
var _createSearchUrl = require("@deosite/helpers/createSearchUrl");
var _createParametrizedUrl = _interopRequireDefault(require("@deosite/helpers/createParametrizedUrl"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var mapToNewFiltersStructure = function mapToNewFiltersStructure(item) {
  var newItem = _objectSpread(_objectSpread({}, item), {}, {
    label: item.name
  });
  if (item.items) {
    newItem.options = item.items.map(function (option) {
      return _objectSpread(_objectSpread({}, option), {}, {
        label: option.name,
        id: option.id + ""
      });
    });
  }
  if (item.type === "color") {
    newItem.type = "multiselect";
  }
  if (item.type === "select") {
    newItem.type = "multiselect";
  }
  return newItem;
};
exports.mapToNewFiltersStructure = mapToNewFiltersStructure;
var fetcher = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(categoryId) {
    var pickedFilters,
      page,
      pageSize,
      query,
      language,
      productsFromCategoryMapped,
      filters,
      narrowedFilters,
      productsTotalCount,
      _yield$Promise$all,
      _yield$Promise$all2,
      productsFromCategory,
      filtersResponse,
      pickedFiltersList,
      allPositionFromPickedFilter,
      currentFiltersWithPickedFilter,
      mappedProducts,
      _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            pickedFilters = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            page = _args.length > 2 && _args[2] !== undefined ? _args[2] : 0;
            pageSize = _args.length > 3 && _args[3] !== undefined ? _args[3] : global.__appConfig__.categoryPageSize;
            query = _args.length > 4 && _args[4] !== undefined ? _args[4] : null;
            language = _args.length > 5 ? _args[5] : undefined;
            productsTotalCount = 0;
            _context.prev = 6;
            _context.next = 9;
            return Promise.all([_agent.requests.get((0, _getSearchUrl["default"])({
              url: "/products",
              currentPage: page,
              query: query,
              pageSize: pageSize,
              pickedFilters: pickedFilters,
              categoryId: categoryId,
              lang: language
            }).replace((0, _createParametrizedUrl["default"])(global.__appConfig__.elasticEndpointUrl, {
              lang: language.language,
              domain: language.domain
            }), ""), true, null, language), categoryId ? _agent.requests.get((0, _createSearchUrl.createSearchUrl)("/deosite/filters/list", [{
              field: "category_id",
              condition_type: "eq",
              value: categoryId,
              connector: _createSearchUrl.CONNECTORS.AND
            }, {
              field: "visibility",
              condition_type: "in",
              value: [2, 4],
              connector: _createSearchUrl.CONNECTORS.AND
            }, {
              field: "type_id",
              value: "simple",
              connector: _createSearchUrl.CONNECTORS.AND
            }]), true, null, language) : {}]);
          case 9:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = (0, _slicedToArray2["default"])(_yield$Promise$all, 2);
            productsFromCategory = _yield$Promise$all2[0];
            filtersResponse = _yield$Promise$all2[1];
            if (filtersResponse !== null && filtersResponse !== void 0 && filtersResponse.items) {
              filters = filtersResponse.items.map(mapToNewFiltersStructure);
            } else if (productsFromCategory.filters.items) {
              filters = productsFromCategory.filters.items.map(mapToNewFiltersStructure);
            }
            pickedFiltersList = Object.keys(pickedFilters);
            if (productsFromCategory.filters.items && pickedFiltersList.length > 1) {
              narrowedFilters = productsFromCategory.filters.items.map(mapToNewFiltersStructure);
            } else if (productsFromCategory.filters.items && pickedFiltersList.length === 1) {
              allPositionFromPickedFilter = filters.map(mapToNewFiltersStructure).find(function (filter) {
                return filter.id === (pickedFiltersList === null || pickedFiltersList === void 0 ? void 0 : pickedFiltersList[0]);
              });
              currentFiltersWithPickedFilter = productsFromCategory.filters.items.map(mapToNewFiltersStructure).map(function (filter) {
                if (filter.id === (pickedFiltersList === null || pickedFiltersList === void 0 ? void 0 : pickedFiltersList[0])) {
                  return allPositionFromPickedFilter;
                }
                return filter;
              });
              narrowedFilters = (0, _toConsumableArray2["default"])(currentFiltersWithPickedFilter);
            } else {
              narrowedFilters = filters;
            }
            if (pickedFilters["sort"]) {
              narrowedFilters.push({
                id: "sort",
                value: pickedFilters["sort"]
              });
            }
            if (filters) {
              filters.forEach(function (filter) {
                if (pickedFilters[filter.id]) {
                  if (filter.type === "multiselect") {
                    filter.value = pickedFilters[filter.id];
                  }
                }
              });
            }
            if (narrowedFilters) {
              narrowedFilters.forEach(function (filter) {
                if (pickedFilters[filter.id]) {
                  if (filter.type === "range") {
                    var _filtersResponse$item;
                    var initialFilter = (_filtersResponse$item = filtersResponse.items) === null || _filtersResponse$item === void 0 ? void 0 : _filtersResponse$item.find(function (initialFilter) {
                      return initialFilter.id === filter.id;
                    });
                    if (initialFilter) {
                      filter.min = initialFilter.min;
                      filter.max = initialFilter.max;
                    }
                  }
                  filter.value = pickedFilters[filter.id];
                }
              });
            }
            if (productsFromCategory.total_count > 0) {
              mappedProducts = (0, _mapProductDataNew["default"])(productsFromCategory.items);
              productsFromCategoryMapped = (pickedFiltersList === null || pickedFiltersList === void 0 ? void 0 : pickedFiltersList.length) === 0 ? (0, _moveOutOfStockProductsLast["default"])(mappedProducts) : mappedProducts;
              productsTotalCount = productsFromCategory.total_count;
            } else {
              productsFromCategoryMapped = [];
            }
            _context.next = 26;
            break;
          case 22:
            _context.prev = 22;
            _context.t0 = _context["catch"](6);
            console.log("There was an error while fetching products from products and filters from category ".concat(categoryId, " ").concat(_context.t0));
            productsFromCategoryMapped = [];
          case 26:
            return _context.abrupt("return", {
              products: productsFromCategoryMapped,
              productsTotalCount: productsTotalCount,
              filters: filters,
              narrowedFilters: narrowedFilters
            });
          case 27:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 22]]);
  }));
  return function fetcher(_x) {
    return _ref.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;